import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveId, setCurrentPage } from "../../features/filter/filterSlice";

const Pagination = () => {
    const dispatch = useDispatch();
    const { videosPerPage, activeId } = useSelector((state) => state.filter);
    const { videos } = useSelector((state) => state.videos);

    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(videos?.length / videosPerPage); i++) {
        pageNumbers.push(i);
    }

    const handlePageChange = (pageNumber) => {
        dispatch(setCurrentPage(pageNumber));

        dispatch(setActiveId(pageNumber));
    };

    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
                {pageNumbers.length !== 1
                    ? pageNumbers.map((number) => {
                          return (
                              <div
                                  key={number}
                                  onClick={() => handlePageChange(number)}
                                  className={`${
                                      activeId === number
                                          ? "bg-blue-600 text-white"
                                          : "bg-blue-100 text-blue-600"
                                  } cursor-pointer  px-4 py-1 rounded-full`}
                              >
                                  {number}
                              </div>
                          );
                      })
                    : null}
            </div>
        </section>
    );
};

export default Pagination;
